<span class="badge bg-success" *ngIf="status === 'Completed'" placement="bottom" ngbTooltip="Completato">C</span>
<span class="badge bg-danger" *ngIf="status === 'Failed'" placement="bottom" ngbTooltip="Fallito">F</span>
<span class="badge bg-warning" *ngIf="status === 'Incomplete'" placement="bottom" ngbTooltip="Incompleto">I</span>
<span class="badge bg-dark" *ngIf="!status" placement="bottom" ngbTooltip="Sconosciuto">S</span>
